import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { setQuickActions } from '../store/quickActions.actions'
import { PCRConstants } from '../../pcr/store/pcr.constants'
import { QuickActionsService } from '../services/quickActions.service'
import { IQuickActionCategory, IQuickActionList } from '../store/quickActions.types'

export function* getQuickActions() {
  const serviceId = yield select(getServiceIdSelector)
  const quickActionsService = new QuickActionsService(serviceId)
  try {
    const response: IQuickActionList = yield call([quickActionsService, quickActionsService.getQuickActions])
    const { entity } = response

    // ------- Dev NOTE: "The below piece of code will get removed when we unsuppressed the Procedures"----------
    const filterArray = [
      'Baby Pod',
      'Environmental Controls',
      'Hearing Precautions',
      'Joint Commission Time Out',
      'Patient Loaded - Cold',
      'Patient Loaded - Hot',
      'Patient Personal Protective Equipment',
      'PediMate',
      'Pediatric Safety Restraint Device',
      'Pediatric Stretcher/Chair',
      'Safety Brief',
      'Safety Restraints',
      'Seizure Precautions',
      'Stretcher/Chair - Moving To',
    ]
    const filteredEntity = entity.filter((ent) => {
      if (ent.name && filterArray.includes(ent.name)) {
        return false
      }
      return true
    })
    // ---------------------------------------------------------------------------------------------------------
    filteredEntity.sort((e1: IQuickActionCategory, e2: IQuickActionCategory) => e1.name.localeCompare(e2.name))

    yield put(setQuickActions(filteredEntity))
  } catch (e) {
    yield put(throwPcrException(`getQuickActions() error: ${e}`))
  }
}
export function* getQuickActionsSaga() {
  yield takeLatest([PCRConstants.CREATE_PCR], getQuickActions)
}
